import { useMutation } from "@apollo/client";
import { Reservation } from "@types";
import CancelClientReservationMutation from "./CancelClientReservationMutation.gql";

interface CancelClientReservationPayload {
  success?: boolean;
  errorMessage?: string;
  clientReservation?: Reservation | null;
}

interface CancelClientReservationResponse {
  cancelClientReservation?: CancelClientReservationPayload;
}

const useCancelClientReservation = () => {
  const [mutate, { loading }] = useMutation<CancelClientReservationResponse>(
    CancelClientReservationMutation,
  );

  const cancelClientReservation = async (): Promise<Reservation> => {
    const { data } = await mutate();
    const payload = data?.cancelClientReservation;

    if (!payload?.success || !payload.clientReservation) {
      throw new Error(payload?.errorMessage || "Une erreur est survenue");
    }

    return payload.clientReservation;
  };

  return {
    cancelClientReservation,
    loading,
  };
};

export default useCancelClientReservation;